import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerPasswordRulesBoxResourceBundleEn(i18next: i18n): void {
  i18next.addResourceBundle('en', 'record-it-components', {
    misc: {
      PasswordRulesBox: {
        requiredLength: 'Password needs to be at least {{requiredLength}} characters long.'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}